<template>
  <div>
    <app-cells><h1 class="title">Product storage</h1></app-cells>
    <app-tabs :tabs="tabs"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'StorageProductStorageLayout',
  components: {AppTabs},
  data() {
    return {
      tabs: [
        {name: 'storage-product-storage-orders', label: 'Orders'},
        {name: 'storage-product-storage-transfers', label: 'Transfers'},
        {name: 'storage-product-storage-stock', label: 'Stock'},
      ],
    }
  },
}
</script>

